import React, { useRef, useState } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';

// Icons
import MoreVertIcon from '@mui/icons-material/MoreVert';

const ViewSplitButton = ({ id, name, isActive, onSelect, options }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleOptionClick = (event, option) => {
    handleClose(event);
    option.onSelected();
  };

  return (
    <>
      <ButtonGroup
        variant={isActive ? 'contained' : 'outlined'}
        ref={anchorRef}
        aria-label="split button"
        sx={{ margin: '4px' }}
      >
        {/* Main action button */}
        <Button onClick={() => onSelect(id)} sx={{ textTransform: 'none', fontWeight: 600 }}>
          {name}
        </Button>
        <Button
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <MoreVertIcon />
        </Button>
      </ButtonGroup>

      <Menu
        anchorEl={anchorRef.current}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={id + '-' + option.text}
            onClick={(event) => handleOptionClick(event, option)}>
            <ListItemText>{option.text}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default React.memo(ViewSplitButton);